import { FC } from 'react';
import useSWRImmutable from 'swr/immutable';

import { RedirectToDefaultPage } from '@rikstv/play-common/src/components/pages/RedirectToDefaultPage';
import { useIsAuthenticated } from '@rikstv/play-common/src/hooks/useIsAuthenticated';

import { getLandingPageContent } from '../../../../apis/sanityClient';
import { AppContent } from '../../components/appContent/AppContent';
import { ArchLeft } from '../../components/archs/ArchLeft';
import { ArchRight } from '../../components/archs/ArchRight';
import { Plug } from '../../components/plug/Plug';
import Quotes from '../../components/quotes/Quotes';
import { SellingPoints } from '../../components/sellingPoints/SellingPoints';
import Services from '../../components/services/Services';
import { TipShortcut } from '../../components/tipShortcut/TipShortcut';

import { Hero } from './Hero';

const Strim: FC = () => {
  const isLoggedIn = useIsAuthenticated();
  const { data, isLoading } = useSWRImmutable('landing-page-content', () => getLandingPageContent());

  if (isLoggedIn) {
    return <RedirectToDefaultPage />;
  }

  if (isLoading || !data) {
    return null;
  }

  return (
    <section className="strim">
      <Hero data={data} />
      <SellingPoints data={data} />
      <ArchRight background="light" />
      <Plug data={data} />
      <Services />
      <ArchLeft background="dark" />
      <Quotes />
      <TipShortcut />
      <AppContent data={data} />
    </section>
  );
};

export default Strim;
